var render = function render(){var _vm=this,_c=_vm._self._c;return _c('contents-table',_vm._g({attrs:{"contents":_vm.references,"modalMessage":_vm.modalMessage,"readonly":_vm.readonly}},_vm.$listeners))
}
var staticRenderFns = []

export { render, staticRenderFns }